// extracted by mini-css-extract-plugin
export var compactFilters = "_ec-4";
export var detailImage = "_ec-1";
export var dropdownContainer = "_ec-2";
export var imageContainer = "_ec-0";
export var selectedCard = "_ec-3";